import { IEventFilterValue, IEventNameOption, IEventParameterOption } from './components/EventFilter/components/EventFilterContent/type';
import { CUSTOM_VALUE } from './components/EventFilter/components/EventFilterContent/config';
import { buildEventParameterDisplayParts } from '@/pages/datalab/pages/ABExperiment/components/EventFilter/components/EventPanel/utils';
import { getName } from '@home/utils/common';

interface IGenerateTitleParams {
  value: IEventFilterValue;
  eventNameOptions: IEventNameOption[];
  eventParameterOptions: IEventParameterOption[];
  getLocalText: (key: string) => string;
  isEn?: boolean;
}

export function generateEventFilterTitle(params: IGenerateTitleParams): string {
  const { value, eventNameOptions, eventParameterOptions, getLocalText, isEn = false } = params;
  const parts: string[] = [];

  const hours = value.hoursSinceRegister === CUSTOM_VALUE
    ? value.hoursSinceRegisterCustom
    : value.hoursSinceRegister;
  if (hours) {
    parts.push(`${getLocalText('hours_since_register')}${hours}h`);
  }

  if (value.eventName) {
    const option = eventNameOptions.find(o => o.value === value.eventName);
    const text = option
      ? getName(isEn, option.textEn ?? option.text, option.textCN ?? option.text)
      : value.eventName;
    parts.push(text || value.eventName);
  }

  const paramParts = buildEventParameterDisplayParts({
    eventParam: value.eventParameter,
    eventParameterOptions,
    isEn,
  });
  if (paramParts.length > 0) {
    parts.push(paramParts.join(', '));
  }

  const minOp = '≥';
  const maxOp = '≥';
  if (value.minValue && value.maxValue) {
    parts.push(`${minOp}${value.minValue} - ${maxOp}${value.maxValue}`);
  } else if (value.minValue) {
    parts.push(`${minOp}${value.minValue}`);
  } else if (value.maxValue) {
    parts.push(`${maxOp}${value.maxValue}`);
  }

  if (parts.length === 0) {
    return getLocalText('please_select');
  }

  return parts.join('; ');
}
